import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Questionnaire from "@/pages/Questionnaire";
import Home from "@/pages/Home";
import Analyze from "@/pages/Analyze";
import AnalysisResult from "@/pages/AnalysisResult";
import AnalysesHistory from "@/pages/AnalysesHistory";
import Discover from "@/pages/Discover";
import ProfileDetail from "@/pages/ProfileDetail";
import Matches from "@/pages/Matches";
import Chat from "@/pages/Chat";
import ProfilePage from "@/pages/Profile";
import Breakup from "@/pages/Breakup";
import JournalNew from "@/pages/JournalNew";
import JournalList from "@/pages/JournalList";
import Timeline from "@/pages/Timeline";
import SafeDate from "@/pages/SafeDate";
import Settings from "@/pages/Settings";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="app-shell bg-aurora min-h-screen flex items-center justify-center">
        <div className="text-[#7A3B52] font-display text-xl heart-pulse">❤</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function GuestOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to={user.questionnaire ? "/home" : "/questionnaire"} replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<GuestOnly><Landing /></GuestOnly>} />
            <Route path="/login" element={<GuestOnly><Login /></GuestOnly>} />
            <Route path="/register" element={<GuestOnly><Register /></GuestOnly>} />
            <Route path="/questionnaire" element={<Protected><Questionnaire /></Protected>} />
            <Route path="/home" element={<Protected><Home /></Protected>} />
            <Route path="/analyze" element={<Protected><Analyze /></Protected>} />
            <Route path="/analyses" element={<Protected><AnalysesHistory /></Protected>} />
            <Route path="/analyses/:id" element={<Protected><AnalysisResult /></Protected>} />
            <Route path="/discover" element={<Protected><Discover /></Protected>} />
            <Route path="/profile/:id" element={<Protected><ProfileDetail /></Protected>} />
            <Route path="/matches" element={<Protected><Matches /></Protected>} />
            <Route path="/chat/:matchId" element={<Protected><Chat /></Protected>} />
            <Route path="/profile" element={<Protected><ProfilePage /></Protected>} />
            <Route path="/breakup" element={<Protected><Breakup /></Protected>} />
            <Route path="/breakup/journal" element={<Protected><JournalList /></Protected>} />
            <Route path="/breakup/journal/new" element={<Protected><JournalNew /></Protected>} />
            <Route path="/timeline" element={<Protected><Timeline /></Protected>} />
            <Route path="/safedate" element={<Protected><SafeDate /></Protected>} />
            <Route path="/settings" element={<Protected><Settings /></Protected>} />
            {/* Terms & Privacy accessible without auth (needed for registration link) */}
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="*" element={<Navigate to="/home" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
